'use strict'

import ajax from '@/plugin/ajax.js'

const queryEmployee = function (
    pageIndex,
    pageSize,
    sortOrder,
    fastSearchFields,
    fastSearchKeyWord,
    departmentId
) {
    return ajax.post('/Sys/Employee/Query', {
        pageSize,
        pageIndex,
        sortOrder,
        fastSearchFields,
        fastSearchKeyWord,
        DepartmentID: departmentId || ''
    })
}
const queryEmployeePickerData = function (
    pageIndex,
    pageSize,
    sortOrder,
    fastSearchFields,
    fastSearchKeyWord,
    departmentId
) {
    return ajax.post('/api/Picker/QueryUser', {
        pageSize,
        pageIndex,
        sortOrder,
        fastSearchFields,
        fastSearchKeyWord,
        DepartmentID: departmentId || ''
    })
}
const saveEmployee = function (model) {
    return ajax.post('/Sys/Employee/Save', model)
}
const deleteEmployee = function (Id) {
    return ajax.post('/Sys/Employee/Delete', {
        Id: Id
    })
}
const disableOrEnabled = function (Id, status) {
    return ajax.post('/Sys/Employee/DisableOrEnabled', {
        Id: Id,
        status: status
    })
}
const querySecondment = function (pageIndex,
    pageSize,
    sortOrder,
    fastSearchFields,
    fastSearchKeyWord, ) {
    return ajax.post('/Sys/EmployeeSecondment/Query', {
        pageSize,
        pageIndex,
        sortOrder,
        fastSearchFields,
        fastSearchKeyWord,
    })
}
const deleteSecondment = function (ids) {
    return ajax.post('/Sys/EmployeeSecondment/Delete', {
        Id: ids
    })
}

const saveSecondment = function (obj) {
    return ajax.post('/Sys/EmployeeSecondment/Save', obj)
}
const updatapaw=function (model) {
    return ajax.post('/api/SysEmployee/UpdatePaw',model)
}

const queryEmployeeNew = function (
    pageIndex,
    pageSize,
    sortOrder,
    fastSearchFields,
    fastSearchKeyWord,
    departmentId
) {
    return ajax.post('/api/SysEmployee/QueryEmployee', {
        pageSize,
        pageIndex,
        sortOrder,
        fastSearchFields,
        fastSearchKeyWord,
        DepartmentID: departmentId || ''
    })
}

const updateOtherPaw = function(model) {
    return ajax.post('/api/SysEmployee/UpdateOtherPaw',model)
}
export {
    queryEmployee,
    saveEmployee,
    deleteEmployee,
    disableOrEnabled,
    queryEmployeePickerData,
    querySecondment,
    deleteSecondment,
    saveSecondment,
    updatapaw,
    updateOtherPaw,
    queryEmployeeNew
}
